export default __webpack_public_path__ + "4ce6ff666da7615f85a2b10d094b1f45.svg";